<!--
 * @Author: 张天昊
 * @Date: 2024-06-24 17:45:07
 * @LastEditTime: 2024-06-28 15:25:12
 * @LastEditors: 张天昊
 * @Description: 自定义navbar右侧插槽
 * @FilePath: /Mobile/src/components/NavBarSlots/right.vue
-->
<script>
import { defineComponent } from 'vue';

import ItineraryUniversalPdfDownload from '@/pages/itineraryUniversal/components/PdfDownload.vue';

export default defineComponent({
  components: {
    ItineraryUniversalPdfDownload
  },
  setup() {}
});
</script>

<template>
  <div class="flex items-center justify-end">
    <!-- 聚合行程单详情右侧定制slot -->
    <template v-if="$route.name === 'itineraryUniversalDetail'">
      <ItineraryUniversalPdfDownload />
    </template>
  </div>
</template>
